$(function () {
    // Configuration variables
    var additionalHeight = 120;
    var verticalAdjustment = additionalHeight / 2;

    function adjustImages() {
        // Handle both flush-right and flush-left elements
        $('.js-flush-right, .js-flush-left').each(function () {
            var $element = $(this);

            // Ensure there is no previous clone before selecting $img
            $element.find('.cloned-img').remove();

            var $img = $element.find('img').not('.js-no-flush');
            var $clonedImg;

            // Clone the image and apply styles and adjustments
            $clonedImg = $img.clone().css({
                position: 'absolute',
                top: ($img.position().top - verticalAdjustment) + 'px',
                opacity: 1,
                height: ($img.height() + additionalHeight) + 'px'
            }).addClass('cloned-img');

            if ($element.hasClass('js-flush-right')) {
                $clonedImg.css({
                    left: '0px',
                    width: ($(window).width() - $element.offset().left) + 'px'
                });
            } else if ($element.hasClass('js-flush-left')) {
                var imgRightEdge = $img.offset().left + $img.outerWidth();
                var leftOffset = $element.offset().left;
                $clonedImg.css({
                    left: -leftOffset + 'px',
                    width: imgRightEdge + 'px'
                });
            }

            // Insert the cloned image
            $element.append($clonedImg);

            // Hide the original image
            $img.css('opacity', 0);
        });
    }

    // Hide originals immediately so there's no flash when the clone takes over
    $('.js-flush-right, .js-flush-left').find('img').not('.js-no-flush').css('opacity', 0);

    // Run after all images have loaded so $img.height() is accurate
    $(window).on('load', adjustImages);

    // Debounced re-adjust on window resize
    var debouncedAdjustImages = debounce(adjustImages, 250);
    $(window).resize(debouncedAdjustImages);
});
